import { faSquareCheck } from '@fortawesome/pro-solid-svg-icons';
import { TableListRow, toGridTemplateColumns } from './TableList';
import { sprinkles } from '@design-system/sprinkles.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowDown,
  faArrowUp,
  faFileExport,
} from '@fortawesome/pro-regular-svg-icons';
import { Box, Checkbox } from '@mui/material';
import { Typography } from '@design-system/components/typography/typography';
import { clsx } from 'clsx';
import { capitalize, isEmpty } from 'lodash';
import { ColumnSchema } from '@client/new/components/StandardTable/StandardTable';
import { faSquare } from '@fortawesome/pro-light-svg-icons';
import { PropsWithChildren } from 'react';
import { Row } from '@design-system/components/grid/grid';
import { IconButton } from '@design-system/components/button/iconButton';
import { Tooltip } from '@mui/material';
type Props = {
  schema: ColumnSchema[];
  listSelection: {
    allSelected: boolean;
    selectAll: () => void;
    onSelect: (value: any) => void;
    selectedIds: any[];
  };
  showGalleryView: boolean;
  rows: TableListRow[];
  searchText: string;
  type: 'files' | 'folders';
  onExport?: () => void;
};
export const ListsWrapper = ({
  schema,
  listSelection,
  showGalleryView,
  rows,
  searchText,
  type,
  children,
  ...p
}: PropsWithChildren<Props>) => {
  return (
    <div className="flex flex-col gap-4">
      <Row
        style={{
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography variant="body" size="small" className="font-bold">
          {capitalize(type)}
        </Typography>
        {p.onExport ? (
          <Tooltip title={'Download CSV'}>
            <Box>
              <IconButton
                icon={faFileExport}
                className={clsx('p2 text-black bg-white')}
                onClick={p.onExport}
              />
            </Box>
          </Tooltip>
        ) : null}
      </Row>
      {searchText && isEmpty(rows) ? (
        <div className="flex flex-col justify-center items-center w-full h-full">
          <div className="flex gap-1">
            <Typography className={sprinkles({ color: 'N-80' })}>
              No results found for:
            </Typography>
            <Typography className="text-black">{searchText}</Typography>
          </div>
          <Typography className={sprinkles({ color: 'N-80' })}>
            Please try searching with another term.
          </Typography>
        </div>
      ) : null}
      {!searchText && isEmpty(rows) ? (
        <Typography>No {type} uploaded yet</Typography>
      ) : (
        <div>
          {showGalleryView ? null : isEmpty(rows) ? null : (
            <div
              style={{
                marginBottom: '8px',
                display: 'grid',
                padding: !listSelection ? '0 16px' : '0 16px 0 0',
                gridTemplateColumns: toGridTemplateColumns(
                  !listSelection ? schema : [{ width: 42 }, ...schema],
                ),
              }}
            >
              {!listSelection || showGalleryView ? null : (
                <Checkbox
                  className="w-[38px] h-[42px]"
                  checkedIcon={
                    <FontAwesomeIcon icon={faSquareCheck} className="w-5 h-5" />
                  }
                  icon={
                    <FontAwesomeIcon
                      icon={faSquare}
                      className="w-5 h-5 text-black"
                    />
                  }
                  checked={listSelection.allSelected}
                  onChange={() => listSelection?.selectAll()}
                />
              )}
              {schema.map((v, i) => (
                <div
                  key={i}
                  className={clsx(
                    'flex items-center gap-1',
                    sprinkles({ textAlign: v.justify }),
                  )}
                >
                  <div
                    className={clsx(
                      'flex items-center gap-1 px-4 py-4 h-[25px]',
                      v?.sort &&
                        'cursor-pointer hover:bg-[#E4E4E4] rounded-[10px]',
                    )}
                    onClick={() => v?.sort && v.sort.onClick()}
                  >
                    <Typography variant="body" size="small" color="N-100">
                      {v.label}
                    </Typography>
                    {v?.sort?.enabled && (
                      <FontAwesomeIcon
                        icon={v.sort.isAsc ? faArrowDown : faArrowUp}
                        className="w-3 h-3"
                      />
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
          {children}
        </div>
      )}
    </div>
  );
};
